import { Component, OnInit } from '@angular/core';
import { CostCenterService } from '../share/costCenter/costcenter.service';
import { TranslateService } from '@ngx-translate/core';
import { CostCenter } from '../share/costCenter/costcenter.model';
import { TerminalActionsSsbtReport } from './terminal-actions-report.type';
import { ReportsService } from '../share/reports/report.service';
import { finalize } from 'rxjs/operators';
import { QueryModel } from '../share/paginationquery.model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';
import { AppSettings } from '../../settings';

@Component({
  selector: 'app-terminal-actions-ssbt-report',
  templateUrl: './terminal-actions-ssbt-report.component.html',
  styleUrls: ['./terminal-actions-ssbt-report.component.css'],
  providers: [CostCenterService, ReportsService]
})
export class TerminalActionsSsbtReportComponent implements OnInit {
  private readonly terminalActionCalculatedChargeType: string = 'CalculatedCharge';
  costCenters: CostCenter[] = [];
  terminalActionsReports: TerminalActionsSsbtReport[] = [];
  costCenterId: number;
  selectedDate: Date[];
  currentPageNumber = 1;
  details = -1;
  isLoadDetails = false;
  filterValue: string;
  terminalActionTypeId: number;
  query: QueryModel = new QueryModel();
  recordsPerPage: number;
  order = '';
  terminalActionTypes: any[] = [];
  lastSearchCostCenterId: number;

  constructor(
    private _translate: TranslateService,
    private _costCenterService: CostCenterService,
    private _reportsService: ReportsService,
    private _toastrService: ToastrService,
    private _spinner: NgxSpinnerService,
    private _settings: AppSettings
  ) {
      this.recordsPerPage = _settings.recordsPerPage;
  }

  ngOnInit() {
    this.loadCostCentersItemsForDropdown();
    this.loadTerminalActionsForDropDown();
  }

  private loadCostCentersItemsForDropdown() {
    this._costCenterService.httpGetUserCostCenters().subscribe(
      data => {
        if (data !== undefined) {
          this.costCenters = data;
          this.costCenters.map((cc) => { cc.costCenterIdAndName = cc.costCenterId + ' ' + cc.name; return cc; });
        }
      },
      err => {
        throw err;
      });
  }

  search = () => {
    if (this.costCenterId != null) {
      if (this.selectedDate == null || this.selectedDate[0] ==  null || this.selectedDate[1] ==  null) {
         this.selectedDate = [this.getCurrentDate(), this.getCurrentDate()]; }
      const dateFrom = new Date(this.selectedDate[0]);
      const dateTo = new Date(this.selectedDate[1]);
      this.loadTerminalActionsReportList(dateFrom, dateTo, this.costCenterId, this.terminalActionTypeId);
    } else
      this._translate.get('Messages.InvalidSearchTerminalActionsSSbt').subscribe(translated => {
        this._toastrService.warning(translated);
      });
  }

  loadTerminalActionsReportList(dateFrom: Date, dateTo: Date, costCenterId: number, terminalActionTypeId: number) {
    this._spinner.show();
    this.currentPageNumber = 1;
    this.lastSearchCostCenterId = costCenterId;
    this._reportsService.httpGetTerminalActionsSsbtReport(dateFrom, dateTo, costCenterId, terminalActionTypeId)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      (data: TerminalActionsSsbtReport[]) => {
        if (data !== undefined) {
          this.terminalActionsReports = data;

          if (this.terminalActionsReports === undefined || this.terminalActionsReports.length === 0) {
            this._translate.get('Messages.NoData').subscribe(translated => {
              this._toastrService.warning(translated);
            });
          } else {
            this.setCalculatedChargeAmountsForPreview();
          }
          this.query.totalItems = data.length;
        }
      },
      err => {
        if (err.error['errorCode'] === 'Err_AccountingNotFound') {
          this._translate.get('Messages.NoAccountingError').subscribe(translated => {
            this._toastrService.error(translated);
          });
        } else if (err.error['errorCode'] === 'Err_PartnerAccountingStateNotFound') {
          this._translate.get('Messages.NoData').subscribe(translated => {
            this._toastrService.warning(translated);
          });
        } else if (err.error['errorCode'] === 'Err_TerminalActionType') {
          this._translate.get('Messages.TerminalActionType').subscribe(translated => {
            this._toastrService.error(translated);
          });
        } else {
          throw err;
        }
        this.terminalActionsReports = [];
      }
    );
  }

  sort(propertyName) {
    if (this.details > -1) return;
    if (this.order === propertyName) {
      this.order = '-' + propertyName;
    } else if (this.order === '-' + propertyName) {
      this.order = propertyName;
    } else {
      this.order = propertyName;
    }
  }

  loadTerminalActionsForDropDown() {
    this._spinner.show();

    this._reportsService.httpGetTerminalActionTypes()
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      data => {
          this.terminalActionTypes = data;

        if (this.terminalActionTypes.length === 0) {
          this._translate.get('Messages.NoTerminalActionTypes').subscribe(translated => {
            this._toastrService.error(translated);
          });
        }
      },
      err => {
        throw err;
      }
    );
  }

  private showReportItem(reportItem: TerminalActionsSsbtReport) {
    if (reportItem != null) {
      this._spinner.show();

      this._reportsService.httpGetTerminalActionReportItemAsHtml(reportItem.date, this.lastSearchCostCenterId,
        reportItem.terminalActionTypeId, reportItem.amount, reportItem.newPartnerAccountingState, this._translate.currentLang)
      .pipe(finalize(() => this._spinner.hide()))
      .subscribe(
      data => {
          this.showReportItemInPrintDialog(data.toString());
      },
      err => {
        throw err;
        }
      );
    }
  }

  private showReportItemInPrintDialog(reportItemHtml: string) {
    const printMethodHtml = ' onload=window.print() ';
    const openBodyTagKeyWord = '<body';
    const positionOfHtmlBodyTag = reportItemHtml.search(openBodyTagKeyWord);

    if (positionOfHtmlBodyTag === 0) {
      return;
    }
    const positionToInsertPrintMethod = positionOfHtmlBodyTag + openBodyTagKeyWord.length;
    reportItemHtml = [reportItemHtml.slice(0, positionToInsertPrintMethod), printMethodHtml,
      reportItemHtml.slice(positionToInsertPrintMethod)].join('');

    const printFrame = window.frames['printFrame'];
    printFrame.document.write(reportItemHtml);
    printFrame.document.close();
  }

  private setCalculatedChargeAmountsForPreview() {
    if (this.terminalActionsReports != null && this.terminalActionsReports.length > 0) {
      this.terminalActionsReports.forEach(reportItem => {
        const terminalAction = this.terminalActionTypes.find(actionType => actionType.id === reportItem.terminalActionTypeId);
        if (terminalAction != null && terminalAction.name === this.terminalActionCalculatedChargeType)
          reportItem.amount = (-1) * reportItem.amount;
      });
    }
  }

  private getCurrentDate() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-actions-ssbt-report/terminal-actions-ssbt-report.component.ts